import { Center, Spinner, Text, useToast } from "@chakra-ui/react"
import ComplaintForm from "components/Organismos/ComplaintForm"
import ComplaintsMapLayer from "components/Organismos/ComplaintsMapLayer"
import PostsMapLayer from "components/Organismos/PostMapLayer"
import FormModalTemplate from "components/Templates/FormModal"
import NewComplaintTemplate from "components/Templates/NewComplaint"
import L from 'leaflet'
import { ComplaintFormData } from "models/complaint.model"
import { useEffect, useRef, useState } from "react"
import { FeatureGroup } from "react-leaflet"
import { useAppDispatch, useTypedSelector } from "store/hooks"
import { createComplaintRequest } from "store/modules/complaints/actions/createComplaint"
import { getComplaintsGeojsonRequest } from "store/modules/complaints/actions/getComplaintsGeojson"
import { getEssentialServicesGeojsonRequest } from "store/modules/posts/actions/getEssentialServicesGeojson"
import { getInformativesGeojsonRequest } from "store/modules/posts/actions/getInformativesGeojson"
import { useDispatchToPromise } from "utils/dispatch-to-promise"
import { useQueryParam } from "utils/hooks/useQueryParam"

const NewComplaintPage = () => {
    const dispatchAsPromise = useDispatchToPromise();
    const [map, setMap] = useState<L.Map | null>(null);
    const featureRef = useRef<L.FeatureGroup>(null);
    const [lat] = useQueryParam<number>('lat');
    const [lng] = useQueryParam<number>('lng');
    const [showNewModal, setShowNewModal] = useQueryParam<boolean>('showNewModal');

    const {
        isRequesting: loadingInformatives,
        successPayload: informatives
    } = useTypedSelector(state => state.posts.getInformativesGeojson);

    const {
        isRequesting: loadingEssentialServices,
        successPayload: essentialServices
    } = useTypedSelector(state => state.posts.getEssentialServicesGeojson);

    const {
        isRequesting: loadingComplaints,
        successPayload: complaints
    } = useTypedSelector(state => state.complaints.getComplaintsGeojson);

    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(getInformativesGeojsonRequest());
        dispatch(getEssentialServicesGeojsonRequest());
        dispatch(getComplaintsGeojsonRequest({ showOnlyUser: true }));
    }, []);

    const closeNewModal = () => {
        setShowNewModal(false);
    }

    const toast = useToast();

    const handleSubmit = async (data: ComplaintFormData): Promise<void> => {
        try {
            await dispatchAsPromise(createComplaintRequest, {
                titulo: data.title,
                descricao: data.description,
                tipoManifestacao: data.type,
                imagem: data.photo,
                latitude: lat!,
                longitude: lng!
            });
            toast({
                status: 'success',
                description: 'Manifestação criada com sucesso.'
            });
            dispatch(getComplaintsGeojsonRequest({ showOnlyUser: true }));
            closeNewModal();
        } catch (err) {
            toast({
                status: 'error',
                description: 'Houve um problema ao cadastrar sua manifestação.'
            })
        }
    }

    // useEffect(() => {
    //     if (map && featureRef.current) {
    //         const bounds = featureRef.current?.getBounds();
    //         if (bounds.isValid()) {
    //             map.fitBounds(bounds);
    //         }
    //     }
    // }, [map, informatives, essentialServices, complaints]);

    if (loadingInformatives || loadingEssentialServices || loadingComplaints) {
        return (
            <Center h="100vh">
                <Spinner />
                <Text ml={4}>Buscando informações...</Text>
            </Center>
        )
    }

    return (
        <>
            <NewComplaintTemplate ref={(ref) => setMap(ref ?? null)} onMarkerChoose={() => setShowNewModal(true)}>
                <FeatureGroup ref={featureRef}>
                    {informatives && (
                        <PostsMapLayer
                            postType="Informativo"
                            features={informatives.features}
                            hideButtons
                        />
                    )}

                    {essentialServices && (
                        <PostsMapLayer
                            postType="Ponto essencial"
                            features={essentialServices.features}
                            hideButtons
                        />
                    )}

                    {complaints && (
                        <ComplaintsMapLayer
                            features={complaints.features}
                            hideButtons
                        />
                    )}
                </FeatureGroup>
            </NewComplaintTemplate>
            <FormModalTemplate
                form={lat && lng && (
                    <ComplaintForm latitude={lat} longitude={lng} onSuccess={handleSubmit} />
                )}
                isOpenModal={String(showNewModal) === 'true'}
                onCloseModal={closeNewModal}
            />
        </>
    )
}
export default NewComplaintPage